export { default as HideAdButton } from "./HideAdButton";


// WEBPACK FOOTER //
// ./src/components/HideAdButton/index.ts